/**
 * @module Components.TrialPriceLine
 *
 * The trial PriceCards' "Then …" line: the discounted first-period price with
 * the original struck through beside it, or the plain price when no discount
 * applies. Companion to DiscountedPrice, which does the same for the purchase
 * title.
 */
import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Currency, formatPrice } from "app/utils/currency";
import { PlanPricing } from "app/hooks/usePlanPricing";
import styles from "./styles.module.scss";

type PropsDef = {
  pricing: PlanPricing;
  currency: Currency;
};

const TrialPriceLine = ({ pricing, currency }: PropsDef) => {
  const { t } = useTranslation();
  const { base, discountedAmount, isDiscounted, discountedI18nKey, interval, billing } = pricing;

  if (!isDiscounted) {
    return (
      <>
        {t("trial_price_regular", {
          price: formatPrice(base, currency),
          interval,
          billing,
        })}
      </>
    );
  }

  return (
    <Trans
      i18nKey={discountedI18nKey}
      values={{
        discounted: formatPrice(discountedAmount, currency),
        original: formatPrice(base, currency),
        interval,
        billing,
      }}
      components={{
        discounted: <span className={styles.discounted} />,
        original: <span className={styles.original} />,
      }}
    />
  );
};

export default TrialPriceLine;
